import React from "react";
import { Range, getTrackBackground } from "react-range";
type Props = Partial<Omit<Range["props"], "onChange" | "value">> & {
  onChange: (value: number) => void;
  value?: number;
  color?: string;
};
const RangeField = ({
  onChange,
  value,
  rtl = false,
  step = 1,
  min = 0,
  max = 100,
  color = "#4daa5d",
}: Props) => {
  return (
    <div className={rtl ? "rtl" : "ltr"}>
      <Range
        values={typeof value === "number" ? [value] : []}
        step={step}
        min={min}
        max={max}
        rtl={rtl}
        onChange={(value) =>
          onChange && onChange(parseFloat(value[0].toFixed(step < 1 ? 1 : 0)))
        }
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            className="d-flex w-100"
            style={{
              ...props.style,
              height: "36px",
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "16px",
                width: "100%",
                borderRadius: "20px",
                border: "4px solid #e9e9e9",
                background: getTrackBackground({
                  values: value !== undefined ? [value] : [],
                  colors: [color, "#f4f4f9"],
                  min: min,
                  max: max,
                  rtl,
                }),
                alignSelf: "center",
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "25px",
              width: "25px",
              backgroundColor: "#FFF",
              borderRadius: "50%",
              border: `2px solid ${color}`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 2px 6px #AAA",
            }}
          ></div>
        )}
      />
    </div>
  );
};

export default React.memo(RangeField);
